export const stepper = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  separator: {
    background: "{content.border.color}",
    activeBackground: "{content.border.color}",
    // margin: "0 0 0 20px",
    size: "{border.width.2}",
  },
  step: {
    padding: "{padding.8}",
    gap: "{gap.16}",
  },
  stepHeader: {
    padding: "0",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
    gap: "{gap.8}",
  },
  stepTitle: {
    color: "{text.subtle-text}",
    activeColor: "{primary.support}",
    fontWeight: "600",
  },
  stepNumber: {
    background: "{content.background}",
    activeBackground: "{content.background}",
    borderColor: "{content.border.color}",
    activeBorderColor: "{content.border.color}",
    color: "{text.subtle-text}",
    activeColor: "{primary.support}",
    size: "32px",
    fontSize: "{typography.table.heading.font.size}",
    fontWeight: "600",
    borderRadius: "50%",
    shadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.06), 0px 1px 1px 0px rgba(0, 0, 0, 0.12)",
  },
  steppanels: {
    padding: "{padding.32} 0 {padding.16} 0",
  },
  steppanel: {
    background: "{content.background}",
    color: "{content.color}",
    padding: "0",
    // indent: "1rem",
  },
  extend: {
    ui: {
      stepTitle: {
        fontSize: "{typography.table.heading.font.size}",
        completedColor: "{text.body}",
      },
      stepNumber: {
        completedColor: "{text.body}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-steppanels {
      display: block;
    }

    .p-step.p-disabled .p-step-title {
      display: none;
    }

    .p-stepper .p-step-title {
      font-size: ${dt("stepper.ui.step.title.font.size")};
    }

    .p-stepper .p-step:has(~ .p-step-active) .p-step-title {
      color: ${dt("stepper.ui.step.title.completed.color")};
    }

    .p-stepper .p-step:has(~ .p-step-active) .p-step-number {
      color: ${dt("stepper.ui.step.number.completed.color")};
    }
  `,
};
